/*
 * @Descripttion:
 * @Date: 2024-05-10 15:43:17
 */
export const route = [
  {
    path: '/company-crm-list',
    name: 'company-crm-list',
    meta: {
      title: 'CRM客户管理'
    },
    component: () => import('../views/company-crm-list/index')
  },
  {
    path: '/company-crm-detail',
    name: 'company-crm-detail',
    meta: {
      title: '详情',
      parentPath: '/company-crm-list'
    },
    component: () => import('../views/company-crm-detail/index')
  }
];
